import React from 'react';
import {useTranslate} from "react-redux-multilingual";
import {Link} from "react-router-dom";
import './overview.scss';

// Arabkir Premium overview (used on /info). Baghramyan Deluxe lives on the home page only.
function OverviewSection() {

    const t = useTranslate();
    return (
        <section className="cpr-section cpr-overview" aria-labelledby="cpr-overview-title">
            <div className="cpr-container cpr-overview__grid">
                <div className="cpr-overview__text">
                    <h1 id="cpr-overview-title" className="cpr-h1">{t('aboutBuilding')}</h1>
                    <div className="cpr-body">
                        <p>{t('aboutBuildingInfo1')}</p>
                        <p>{t('aboutBuildingInfo2')}</p>
                    </div>
                    <Link to="/arabkir" className="cpr-btn cpr-btn--primary">{t('select_apartment')}</Link>
                </div>
                <picture className="cpr-overview__media">
                    <source type="image/webp"
                            srcSet="/assets/images/cpr/arabkir-cutout-768.webp 768w, /assets/images/cpr/arabkir-cutout-1537.webp 1537w"
                            sizes="(min-width: 1024px) 50vw, 100vw"/>
                    <img src="/assets/images/building/building.png" alt={t('aboutBuilding')}
                         width="1537" height="978" decoding="async"/>
                </picture>
            </div>
        </section>
    )
}

export default OverviewSection
